export default [
  // Users Routes
  {
    path: '/home',
    name: 'home.index',
    component: () => import('@/pages/Home/Index'),

    // If the user needs to be authenticated to view this page
    meta: {
      perimeter: 'AuthPerimeter',
    },
  },

  // Account
  {
    path: '/account',
    name: 'account.index',
    component: () => import('@/pages/Account/Index'),
    meta: {
      perimeter: 'AuthPerimeter',
    },
  },

  // Companies
  {
    path: '/companies',
    name: 'companies.index',
    component: () => import('@/pages/RegularUser/Companies/Index'),
    meta: {
      perimeter: 'BaseOrAgentRolePerimeter',
    },
  },

  {
    path: '/companies/create',
    name: 'companies.create',
    component: () => import('@/pages/RegularUser/Companies/CreateCompany'),
    meta: {
      perimeter: 'BaseOrAgentRolePerimeter',
    },
  },

  {
    path: '/companies/:id/emails',
    name: 'companies.emails',
    component: () => import('@/pages/RegularUser/Companies/Show/CompanyEmails'),
    meta: {
      perimeter: 'BaseOrAgentRolePerimeter',
    },
  },

  {
    path: '/companies/:id/email',
    name: 'companies.email',
    component: () => import('@/pages/RegularUser/Companies/Show/CompanyEmail'),
    meta: {
      perimeter: 'AuthPerimeter',
    },
  },

  {
    path: '/companies/:id/edit',
    name: 'companies.edit',
    component: () => import('@/pages/RegularUser/Companies/Show/CompanyEdit'),
    meta: {
      perimeter: 'BaseOrAgentRolePerimeter',
      company: true,
    },
  },

  {
    path: '/companies/:id/surveys',
    name: 'companies.surveys.index',
    component: () => import('@/pages/RegularUser/Companies/Show/CompanySurveys'),
    meta: {
      perimeter: 'BaseOrAgentRolePerimeter',
      company: true,
    },
  },

  {
    path: '/companies/:id/contacts',
    name: 'companies.contacts',
    component: () => import('@/pages/RegularUser/Companies/Show/CompanyContacts'),
    meta: {
      perimeter: 'BaseOrAgentRolePerimeter',
      company: true,
    },
  },

  {
    path: '/companies/:id/contacts/create/:contactId?',
    name: 'companies.contacts.create',
    component: () => import('@/pages/RegularUser/Companies/Show/CompanyContactCreate'),
    meta: {
      perimeter: 'BaseOrAgentRolePerimeter',
      company: true,
    },
  },

  {
    path: '/companies/:id/contacts/edit/:contactId',
    name: 'companies.contacts.edit',
    component: () => import('@/pages/RegularUser/Companies/Show/CompanyContactEdit'),
    meta: {
      perimeter: 'BaseOrAgentRolePerimeter',
      company: true,
    },
  },

  {
    path: '/companies/:id/handovers',
    name: 'companies.handovers.index',
    component: () => import('@/pages/RegularUser/Companies/Show/CompanyHandovers'),
    meta: {
      perimeter: 'BaseOrAgentRolePerimeter',
      company: true,
    },
  },

  {
    path: '/companies/:id/errors',
    name: 'companies.errors',
    component: () => import('@/pages/RegularUser/Companies/Show/CompanyErrors'),
    meta: {
      perimeter: 'BaseOrAgentRolePerimeter',
      company: true,
    },
  },

  {
    path: '/companies/:id/errors/create/:error_id?',
    name: 'companies.errors.create',
    component: () => import('@/pages/RegularUser/Companies/Show/CompanyErrorCreate'),
    meta: {
      perimeter: 'BaseOrAgentRolePerimeter',
      company: true,
    },
  },

  {
    path: '/companies/:id/errors/edit/:error_id',
    name: 'companies.errors.edit',
    component: () => import('@/pages/RegularUser/Companies/Show/CompanyErrorEdit'),
    meta: {
      perimeter: 'BaseOrAgentRolePerimeter',
      company: true,
    },
  },

  {
    path: '/companies/:id/journal',
    name: 'companies.journal',
    component: () => import('@/pages/RegularUser/Companies/Show/CompanyJournal'),
    meta: {
      perimeter: 'BaseOrAgentRolePerimeter',
      company: true,
    },
  },

  {
    path: '/companies/:id/journal/create',
    name: 'companies.journal.create',
    component: () => import('@/pages/RegularUser/Companies/Show/CompanyJournalCreate'),
    meta: {
      perimeter: 'BaseOrAgentRolePerimeter',
      company: true,
    },
  },

  {
    path: '/companies/:id/journal/edit/:journalId',
    name: 'companies.journal.edit',
    component: () => import('@/pages/RegularUser/Companies/Show/CompanyJournalEdit'),
    meta: {
      perimeter: 'BaseOrAgentRolePerimeter',
      company: true,
    },
  },

  {
    path: '/companies/:id/actions',
    name: 'companies.actions',
    component: () => import('@/pages/RegularUser/Companies/Show/CompanyActions'),
    meta: {
      perimeter: 'BaseOrAgentRolePerimeter',
      company: true,
    },
  },

  {
    path: '/companies/:id/actions/create/:actionId?',
    name: 'companies.actions.create',
    component: () => import('@/pages/RegularUser/Companies/Show/CompanyActionsCreate'),
    meta: {
      perimeter: 'BaseOrAgentRolePerimeter',
      company: true,
    },
  },

  {
    path: '/companies/:id/actions/edit/:actionId',
    name: 'companies.actions.edit',
    component: () => import('@/pages/RegularUser/Companies/Show/CompanyActionsEdit'),
    meta: {
      perimeter: 'BaseOrAgentRolePerimeter',
      company: true,
    },
  },

  {
    path: '/companies/:id/article-prices',
    name: 'companies.article-prices.index',
    component: () => import('@/pages/RegularUser/Companies/Show/CompanyArticles'),
    meta: {
      perimeter: 'BaseOrAgentRolePerimeter',
      company: true,
    },
  },

  {
    path: '/companies/:id/catalogues/create/:catalogueId?',
    name: 'companies.catalogues.create',
    component: () => import('@/pages/RegularUser/Companies/Show/CompanyCatalogueCreate'),
    meta: {
      perimeter: 'BaseOrAgentRolePerimeter',
      company: true,
    },
  },

  {
    path: '/companies/:id/catalogues/:catalogueId',
    name: 'companies.catalogues.edit',
    component: () => import('@/pages/RegularUser/Companies/Show/CompanyCatalogueEdit'),
    meta: {
      perimeter: 'BaseOrAgentRolePerimeter',
      company: true,
    },
  },

  {
    path: '/companies/:id/standard-catalogues/:catalogueId/prices',
    name: 'companies.catalogues.standard-prices',
    component: () => import('@/pages/RegularUser/Companies/Show/CompanyStandardPrices'),
    meta: {
      perimeter: 'BaseOrAgentRolePerimeter',
      company: true,
    },
  },

  {
    path: '/companies/:id/catalogues/:catalogueId/prices',
    name: 'companies.catalogues.prices',
    component: () => import('@/pages/RegularUser/Companies/Show/CompanyCustomPrices'),
    meta: {
      perimeter: 'BaseOrAgentRolePerimeter',
      company: true,
    },
  },

  {
    path: '/companies/:id/draft-catalogues/:catalogueId/prices',
    name: 'companies.draft-catalogues.prices',
    component: () => import('@/pages/RegularUser/Companies/Show/DraftCataloguePrices'),
    meta: {
      perimeter: 'BaseOrAgentRolePerimeter',
      company: true,
    },
  },

  // Journal
  {
    path: '/journal',
    name: 'journal.index',
    component: () => import('@/pages/RegularUser/JournalRecords/Index'),
    meta: {
      perimeter: 'BaseOrAgentRolePerimeter',
    },
  },

  {
    path: '/journal/create',
    name: 'journal.create',
    component: () => import('@/pages/RegularUser/JournalRecords/Create'),
    meta: {
      perimeter: 'BaseOrAgentRolePerimeter',
    },
  },

  {
    path: '/journal/:id',
    name: 'journal.edit',
    component: () => import('@/pages/RegularUser/JournalRecords/Edit'),
    meta: {
      perimeter: 'BaseOrAgentRolePerimeter',
    },
  },

  // Contacts
  {
    path: '/contacts',
    name: 'contacts.index',
    component: () => import('@/pages/RegularUser/Contacts/Index'),
    meta: {
      perimeter: 'BaseOrAgentRolePerimeter',
    },
  },

  {
    path: '/contacts/:id/emails',
    name: 'contacts.emails',
    component: () => import('@/pages/RegularUser/Contacts/Emails'),
    meta: {
      perimeter: 'BaseOrAgentRolePerimeter',
    },
  },

  {
    path: '/contacts/create/:id?',
    name: 'contacts.create',
    component: () => import('@/pages/RegularUser/Contacts/Create'),
    meta: {
      perimeter: 'BaseOrAgentRolePerimeter',
    },
  },

  {
    path: '/contacts/edit/:id',
    name: 'contacts.edit',
    component: () => import('@/pages/RegularUser/Contacts/Edit'),
    meta: {
      perimeter: 'BaseOrAgentRolePerimeter',
    },
  },

  // Cases
  {
    path: '/cases/create',
    name: 'cases.create',
    component: () => import('@/pages/RegularUser/Cases/Create'),
    meta: {
      perimeter: 'BaseOrAgentRolePerimeter',
    },
  },

  {
    path: '/cases/edit/:id',
    name: 'cases.edit',
    component: () => import('@/pages/RegularUser/Cases/Edit'),
    meta: {
      perimeter: 'BaseOrAgentRolePerimeter',
    },
  },

  {
    path: '/cases/:id?',
    name: 'cases.index',
    component: () => import('@/pages/RegularUser/Cases/Index'),
    meta: {
      perimeter: 'BaseOrAgentRolePerimeter',
    },
  },

  // Actions
  {
    path: '/actions/create/:id?',
    name: 'actions.create',
    component: () => import('@/pages/RegularUser/Actions/Create'),
    meta: {
      perimeter: 'BaseOrAgentRolePerimeter',
    },
  },

  {
    path: '/actions/edit/:id',
    name: 'actions.edit',
    component: () => import('@/pages/RegularUser/Actions/Edit'),
    meta: {
      perimeter: 'BaseOrAgentRolePerimeter',
    },
  },

  {
    path: '/actions',
    name: 'actions.index',
    component: () => import('@/pages/RegularUser/Actions/Index'),
    meta: {
      perimeter: 'BaseOrAgentRolePerimeter',
    },
    children: [
      {
        path: 'view/:id',
        name: 'actions.view',
        meta: {
          perimeter: 'BaseOrAgentRolePerimeter',
          layout: 'kanban',
        },
      },
    ],
  },
  {
    path: '/archived-actions',
    name: 'actions.archived',
    component: () => import('@/pages/RegularUser/Actions/Archived'),
    meta: {
      perimeter: 'BaseOrAgentRolePerimeter',
    },
  },
  {
    path: '/actions/scrum',
    name: 'actions.scrum',
    component: () => import('@/pages/RegularUser/Actions/Kanban'),
    meta: {
      perimeter: 'BaseOrAgentRolePerimeter',
    },
  },
  // Order Campaigns
  {
    path: '/settings/campaigns/create',
    name: 'settings.campaigns.create',
    component: () => import('@/pages/Settings/Universal/Create'),
    meta: {
      perimeter: 'SlsPerimeter',
      entity: 'Campaign',
      path: 'campaigns',
    },
  },

  {
    path: '/settings/campaigns/edit/:id',
    name: 'settings.campaigns.edit',
    component: () => import('@/pages/Settings/Universal/Edit'),
    meta: {
      perimeter: 'SlsPerimeter',
      entity: 'Campaign',
      path: 'campaigns',
    },
  },

  {
    path: '/settings/campaigns',
    name: 'settings.campaigns.index',
    component: () => import('@/pages/Settings/Universal/Index'),
    meta: {
      perimeter: 'SlsPerimeter',
      entity: 'Campaign',
      path: 'campaigns',
    },
  },

  // Projects

  {
    path: '/projects/create',
    name: 'projects.create',
    component: () => import('@/pages/RegularUser/Projects/Create'),
    meta: {
      perimeter: 'BaseRolePerimeter',
    },
  },

  {
    path: '/projects/edit/:id',
    name: 'projects.edit',
    component: () => import('@/pages/RegularUser/Projects/Edit'),
    meta: {
      perimeter: 'BaseRolePerimeter',
    },
  },

  {
    path: '/projects',
    name: 'projects.index',
    component: () => import('@/pages/RegularUser/Projects/Index'),
    meta: {
      perimeter: 'BaseRolePerimeter',
    },
  },

  {
    path: '/projects/:id/emails',
    name: 'projects.emails',
    component: () => import('@/pages/RegularUser/Projects/Emails'),
    meta: {
      perimeter: 'BaseRolePerimeter',
    },
  },

  {
    path: '/projects/:id/email',
    name: 'projects.email',
    component: () => import('@/pages/RegularUser/Projects/Email'),
    meta: {
      perimeter: 'AuthPerimeter',
    },
  },

  // Errors

  {
    path: '/errors/create',
    name: 'errors.create',
    component: () => import('@/pages/RegularUser/Errors/Create'),
    meta: {
      perimeter: 'BaseRoleNotAgentPerimeter',
    },
  },

  {
    path: '/errors/edit/:id',
    name: 'errors.edit',
    component: () => import('@/pages/RegularUser/Errors/Edit'),
    meta: {
      perimeter: 'BaseRoleNotAgentPerimeter',
    },
  },

  {
    path: '/errors',
    name: 'errors.index',
    component: () => import('@/pages/RegularUser/Errors/Index'),
    meta: {
      perimeter: 'BaseRoleNotAgentPerimeter',
    },
  },

  // Errors (new)

  {
    path: '/errors-v2/create',
    name: 'errors-v2.create',
    component: () => import('@/pages/RegularUser/ErrorV2s/Create'),
    meta: {
      perimeter: 'BaseRoleNotAgentPerimeter',
    },
  },

  {
    path: '/errors-v2/edit/:id',
    name: 'errors-v2.edit',
    component: () => import('@/pages/RegularUser/ErrorV2s/Edit'),
    meta: {
      perimeter: 'BaseRoleNotAgentPerimeter',
    },
  },

  {
    path: '/errors-v2',
    name: 'errors-v2.index',
    component: () => import('@/pages/RegularUser/ErrorV2s/Index'),
    meta: {
      perimeter: 'BaseRoleNotAgentPerimeter',
    },
  },

  // Stock lists

  {
    path: '/stock-lists/create/:id?',
    name: 'stock-lists.create',
    component: () => import('@/pages/RegularUser/StockLists/Create'),
    meta: {
      perimeter: 'BaseRoleNotAgentPerimeter',
    },
  },

  {
    path: '/stock-lists/:id/stock-lots',
    name: 'stock-lists.view',
    component: () => import('@/pages/RegularUser/StockLists/IndexStockLots'),
    meta: {
      perimeter: 'BaseRoleNotAgentPerimeter',
    },
  },

  {
    path: '/stock-lists/edit/:id',
    name: 'stock-lists.edit',
    component: () => import('@/pages/RegularUser/StockLists/Edit'),
    meta: {
      perimeter: 'BaseRoleNotAgentPerimeter',
    },
  },

  {
    path: '/stock-lists',
    name: 'stock-lists.index',
    component: () => import('@/pages/RegularUser/StockLists/Index'),
    meta: {
      perimeter: 'BaseRoleNotAgentPerimeter',
    },
  },

  {
    path: '/stock-lists/:id/stock-lots/create/:stockLotId?',
    name: 'stock-lots.create',
    component: () => import('@/pages/RegularUser/StockLists/CreateStockLot'),
    meta: {
      perimeter: 'BaseRoleNotAgentPerimeter',
    },
  },

  {
    path: '/stock-lists/:id/stock-lots/edit/:stockLotId',
    name: 'stock-lots.edit',
    component: () => import('@/pages/RegularUser/StockLists/EditStockLot'),
    meta: {
      perimeter: 'BaseRoleNotAgentPerimeter',
    },
  },

  // Articles

  {
    path: '/articles',
    name: 'articles.index',
    component: () => import('@/pages/RegularUser/Articles/Index'),
    meta: {
      perimeter: 'MyHpBasePerimeter',
    },
  },

  {
    path: '/articles-custom',
    name: 'articles.index.custom',
    component: () => import('@/pages/RegularUser/Articles/IndexCustom'),
    meta: {
      perimeter: 'MyHpBasePerimeter',
    },
  },

  {
    path: '/articles/product-details/:id',
    name: 'articles.product_details',
    component: () => import('@/pages/RegularUser/Articles/ProductDetails'),
    meta: {
      perimeter: 'MyHpPerimeter',
    },
  },

  {
    path: '/articles/myh/:id',
    name: 'articles.my_h',
    component: () => import('@/pages/RegularUser/Articles/MyH'),
    meta: {
      perimeter: 'MyHpPerimeter',
    },
  },

  {
    path: '/articles/files/:id',
    name: 'articles.files',
    component: () => import('@/pages/RegularUser/Articles/Data'),
    meta: {
      perimeter: 'MyHpPerimeter',
    },
  },

  {
    path: '/articles/aliases/:id',
    name: 'articles.aliases',
    component: () => import('@/pages/RegularUser/Articles/CompanyWinlineArticles'),
    meta: {
      perimeter: 'MyHpPerimeter',
    },
  },

  {
    path: '/articles/hidden/:id',
    name: 'articles.hidden',
    component: () => import('@/pages/RegularUser/Articles/HiddenValues'),
    meta: {
      perimeter: 'MyHpPerimeter',
    },
  },

  {
    path: '/articles/create/:id?',
    name: 'articles.create',
    component: () => import('@/pages/RegularUser/Articles/Create'),
    meta: {
      perimeter: 'MyHpBasePerimeter',
    },
  },

  {
    path: '/articles/labels/generator',
    name: 'articles.labels.generator',
    component: () => import('@/pages/RegularUser/Articles/Labels/LabelGenerator'),
    meta: {
      perimeter: 'MyHpBasePerimeter',
    },
  },

  // Draft articles

  // {
  //   path: '/draft-articles/create/:id?',
  //   name: 'draft-articles.create',
  //   component: () => import('@/pages/RegularUser/DraftArticles/Create'),
  //   meta: {
  //     perimeter: 'BaseRolePerimeter',
  //   },
  // },
  //
  // {
  //   path: '/draft-articles/edit/:id',
  //   name: 'draft-articles.edit',
  //   component: () => import('@/pages/RegularUser/DraftArticles/Edit'),
  //   meta: {
  //     perimeter: 'BaseRolePerimeter',
  //   },
  // },
  //
  // {
  //   path: '/draft-articles',
  //   name: 'draft-articles.index',
  //   component: () => import('@/pages/RegularUser/DraftArticles/Index'),
  //   meta: {
  //     perimeter: 'BaseRolePerimeter',
  //   },
  // },

  // Sample positions
  // {
  //   path: '/sample-positions',
  //   name: 'sample-positions.index',
  //   component: () => import('@/pages/Specials/SamplePositions/Index'),
  //   meta: {
  //     perimeter: 'PdmPerimeter',
  //   },
  // },
  //
  // {
  //   path: '/sample-positions/create',
  //   name: 'sample-positions.create',
  //   component: () => import('@/pages/Specials/SamplePositions/Create'),
  //   meta: {
  //     perimeter: 'PdmPerimeter',
  //   },
  // },
  //
  // {
  //   path: '/sample-positions/edit/:id',
  //   name: 'sample-positions.edit',
  //   component: () => import('@/pages/Specials/SamplePositions/Edit'),
  //   meta: {
  //     perimeter: 'PdmPerimeter',
  //   },
  // },

  {
    path: '/article-inquiries/create',
    name: 'article-inquiries.create',
    component: () => import('@/pages/RegularUser/ArticleInquiries/Create'),
    meta: {
      perimeter: 'PdmPerimeter',
    },
  },

  {
    path: '/article-inquiries/edit/:id',
    name: 'article-inquiries.edit',
    component: () => import('@/pages/RegularUser/ArticleInquiries/Edit'),
    meta: {
      perimeter: 'PdmPerimeter',
    },
  },

  {
    path: '/article-inquiries/distribute/:id',
    name: 'article-inquiries.distribute',
    component: () => import('@/pages/RegularUser/ArticleInquiries/Distribute'),
    meta: {
      perimeter: 'PdmPerimeter',
    },
  },

  {
    path: '/article-inquiries/results/:id',
    name: 'article-inquiries.results',
    component: () => import('@/pages/RegularUser/ArticleInquiries/Results'),
    meta: {
      perimeter: 'PdmPerimeter',
    },
  },

  {
    path: '/article-inquiries/results',
    name: 'article-inquiries.results.list',
    component: () => import('@/pages/RegularUser/ArticleInquiries/IndexResults'),
    meta: {
      perimeter: 'PdmPerimeter',
    },
  },

  {
    path: '/article-inquiries',
    name: 'article-inquiries.index',
    component: () => import('@/pages/RegularUser/ArticleInquiries/Index'),
    meta: {
      perimeter: 'PdmPerimeter',
    },
  },

  {
    path: '/news/',
    name: 'news.index',
    component: () => import('@/pages/Specials/News'),
    meta: {
      perimeter: 'BaseRoleNotAgentPerimeter',
    },
  },

  {
    path: '/checklists',
    name: 'checklists.index',
    component: () => import('@/pages/RegularUser/Checklists/Index'),
    meta: {
      perimeter: 'BaseRoleNotAgentPerimeter',
    },
  },

  // goals
  {
    path: '/goals',
    name: 'goals.index',
    component: () => import('@/pages/RegularUser/Goals/Index'),
    meta: {
      perimeter: 'BaseRoleNotAgentPerimeter',
    },
  },

  {
    path: '/goals/create',
    name: 'goals.create',
    component: () => import('@/pages/RegularUser/Goals/Create'),
    meta: {
      perimeter: 'BaseRoleNotAgentPerimeter',
    },
  },

  {
    path: '/goals/edit/:id',
    name: 'goals.edit',
    component: () => import('@/pages/RegularUser/Goals/Edit'),
    meta: {
      perimeter: 'BaseRoleNotAgentPerimeter',
    },
  },

  // target stock
  {
    path: '/target-stock',
    name: 'target-stock.index',
    component: () => import('@/pages/RegularUser/TargetStock/Index'),
    meta: {
      perimeter: 'BaseRoleNotAgentPerimeter',
    },
  },

  {
    path: '/target-stock/create',
    name: 'target-stock.create',
    component: () => import('@/pages/RegularUser/TargetStock/Create'),
    meta: {
      perimeter: 'BaseRoleNotAgentPerimeter',
    },
  },

  {
    path: '/target-stock/edit/:id',
    name: 'target-stock.edit',
    component: () => import('@/pages/RegularUser/TargetStock/Edit'),
    meta: {
      perimeter: 'BaseRoleNotAgentPerimeter',
    },
  },

  {
    path: '/target-stock/articles/:id',
    name: 'target-stock.lines',
    component: () => import('@/pages/RegularUser/TargetStock/Lines'),
    meta: {
      perimeter: 'BaseRoleNotAgentPerimeter',
    },
  },

  // offers

  {
    path: '/offers',
    name: 'offers.index',
    component: () => import('@/pages/RegularUser/Offers/Index'),
    meta: {
      perimeter: 'SlsPerimeter',
    },
  },

  {
    path: '/offer-articles',
    name: 'offers-articles.index',
    component: () => import('@/pages/RegularUser/Offers/FreeArticles'),
    meta: {
      perimeter: 'SlsPerimeter',
    },
  },

  {
    path: '/offers/create/:id?',
    name: 'offers.create',
    component: () => import('@/pages/RegularUser/Offers/Create'),
    meta: {
      perimeter: 'SlsPerimeter',
    },
  },

  {
    path: '/offers/edit/:id',
    name: 'offers.edit',
    component: () => import('@/pages/RegularUser/Offers/Edit'),
    meta: {
      perimeter: 'SlsPerimeter',
    },
  },

  {
    path: '/companies/:id/offers',
    name: 'companies.offers.index',
    component: () => import('@/pages/RegularUser/Companies/Show/CompanyOffers'),
    meta: {
      perimeter: 'SlsPerimeter',
      company: true,
    },
  },

  {
    path: '/companies/:id/offers/create/:offer_id?',
    name: 'companies.offers.create',
    component: () => import('@/pages/RegularUser/Companies/Show/CompanyOfferCreate'),
    meta: {
      perimeter: 'SlsPerimeter',
      company: true,
    },
  },

  {
    path: '/companies/:id/offers/edit/:offer_id',
    name: 'companies.offers.edit',
    component: () => import('@/pages/RegularUser/Companies/Show/CompanyOfferEdit'),
    meta: {
      perimeter: 'SlsPerimeter',
      company: true,
    },
  },

  // Transport projects
  {
    path: '/transport-projects',
    name: 'transport-projects.index',
    component: () => import('@/pages/RegularUser/TransportProjects/Index'),
    meta: {
      perimeter: 'BaseOrAgentRolePerimeter',
    },
  },

  {
    path: '/transport-projects/priority-cockpit/',
    name: 'transport-projects.priority-cockpit',
    component: () => import('@/pages/RegularUser/TransportProjects/PriorityCockpit'),
    meta: {
      perimeter: 'BaseOrAgentRolePerimeter',
    },
  },

  {
    path: '/transport-projects/cockpit/:id',
    name: 'transport-projects.cockpit',
    component: () => import('@/pages/RegularUser/TransportProjects/Cockpit'),
    meta: {
      perimeter: 'BaseOrAgentRolePerimeter',
    },
  },

  {
    path: '/transport-projects/time-trigger-cockpit',
    name: 'transport-projects.time-trigger-cockpit',
    component: () => import('@/pages/RegularUser/TransportProjects/-timeTriggerCockpit/Index'),
    meta: {
      perimeter: 'BaseOrAgentRolePerimeter',
    },
  },

  {
    path: '/transport-projects/calendar',
    name: 'transport-projects.calendar',
    component: () => import('@/pages/RegularUser/TransportProjects/Calendar'),
    meta: {
      perimeter: 'BaseOrAgentRolePerimeter',
    },
  },

  {
    path: '/transport-projects/connections',
    name: 'transport-projects.connections',
    component: () => import('@/pages/RegularUser/TransportProjects/Connections'),
    meta: {
      perimeter: 'BaseOrAgentRolePerimeter',
    },
  },

  {
    path: '/transport-projects/otd',
    name: 'transport-projects.otd-kpi',
    component: () => import('@/pages/RegularUser/TransportProjects/OtdKpiGrid'),
    meta: {
      perimeter: 'BaseOrAgentRolePerimeter',
    },
  },

  {
    path: '/transport-projects/kpi',
    name: 'transport-projects.kpi',
    component: () => import('@/pages/RegularUser/TransportProjects/Kpi'),
    meta: {
      perimeter: 'BaseOrAgentRolePerimeter',
    },
  },

  {
    path: '/transport-projects/trends',
    name: 'transport-projects.trends',
    component: () => import('@/pages/RegularUser/TransportProjects/Trends'),
    meta: {
      perimeter: 'BaseOrAgentRolePerimeter',
    },
  },

  // {
  //   path: '/transport-projects/otd-grid',
  //   name: 'transport-projects.otd-kpi-grid',
  //   component: () => import('@/pages/RegularUser/TransportProjects/OtdKpiGrid'),
  //   meta: {
  //     perimeter: 'BaseOrAgentRolePerimeter',
  //   },
  // },

  {
    path: '/transport-projects/own-warehouse-bookings',
    name: 'transport-projects.own-warehouse-bookings',
    component: () => import('@/pages/RegularUser/TransportProjects/OwnWarehouseBookings'),
    meta: {
      perimeter: 'BaseOrAgentRolePerimeter',
    },
  },

  {
    path: '/transport-projects/open-loading',
    name: 'transport-projects.open-loading',
    component: () => import('@/pages/RegularUser/TransportProjects/OpenLoadingPoints'),
    meta: {
      perimeter: 'BaseOrAgentRolePerimeter',
    },
  },

  {
    path: '/transport-projects/open-delivery',
    name: 'transport-projects.open-delivery',
    component: () => import('@/pages/RegularUser/TransportProjects/OpenDeliveryPlaces'),
    meta: {
      perimeter: 'BaseOrAgentRolePerimeter',
    },
  },

  // OKR

  {
    path: '/objectives',
    name: 'objectives.index',
    component: () => import('@/pages/RegularUser/Objectives/Index'),
    meta: {
      perimeter: 'AuthPerimeter',
    },
  },

  {
    path: '/objectives/create/:id?',
    name: 'objectives.create',
    component: () => import('@/pages/RegularUser/Objectives/Create'),
    meta: {
      perimeter: 'AuthPerimeter',
    },
  },

  {
    path: '/objectives/edit/:id',
    name: 'objectives.edit',
    component: () => import('@/pages/RegularUser/Objectives/Edit'),
    meta: {
      perimeter: 'AuthPerimeter',
    },
  },

  // OKR Backlog
  {
    path: '/okr-backlogs',
    name: 'okr-backlogs.index',
    component: () => import('@/pages/RegularUser/Objectives/OkrBacklogs/Index'),
    meta: {
      perimeter: 'AuthPerimeter',
    },
  },

];



// WEBPACK FOOTER //
// ./src/routes/auth.js